/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { protectedResources, siteData } from "authConfig";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import useFetchWithMsal from "hooks/useFetchWithMsal";
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import profilePhoto from "../../assets/images/icons/projectIcons/Mask Group 1.png";
import logo from "../../assets/images/icons/projectIcons/cropped-A.png";
import Ramsay from "../../assets/images/icons/projectIcons/Ramsay.png";
import Orica from "../../assets/images/icons/projectIcons/orica.png";

function Profile() {
  const { execute } = useFetchWithMsal({
    scopes: [siteData?.apiScopes],
  });

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  // const [formData, setFormData] = useState({
  //   companyLogo: null,
  //   companyName: "",
  //   userName: "",
  //   userPhoto: null,
  // });
  const [formData, setFormData] = useState({
    companyLogo: "",
    companyName: "",
    userName: "",
    userPhoto: "",
    id: "",
  });
  const profileSettingFetched = useRef(false);
  // ID31 — two-axis notification preferences. Frequency defaults to None (email opt-in); sensitivity
  // defaults to Extreme to match the User model / server default, so a user who never changed it
  // isn't shown/saved as "None" and silently opted out of bell alerts. (B)
  const [notificationFrequency, setNotificationFrequency] = useState("none");
  const [notificationSensitivity, setNotificationSensitivity] = useState("extreme");
  // ID160 — signpost alert preference.
  const [notificationSignpostAlert, setNotificationSignpostAlert] = useState("when_triggered_only");
  const userMeFetched = useRef(false);

  // ID30 — change-password dialog state.
  const [passwordOpen, setPasswordOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pwError, setPwError] = useState("");
  const [pwSaving, setPwSaving] = useState(false);
  const [pwDone, setPwDone] = useState(false);

  // ID31 — notification frequency + sensitivity options.
  const FREQUENCY_OPTIONS = [
    { value: "none", label: "None" },
    { value: "weekly", label: "Weekly" },
    { value: "daily", label: "Daily" },
    { value: "immediate", label: "Immediate" },
  ];
  const SENSITIVITY_OPTIONS = [
    { value: "none", label: "None" },
    { value: "extreme", label: "Extreme only" },
    { value: "high", label: "High and above" },
    { value: "medium", label: "Medium and above" },
    { value: "low", label: "Low and above" },
    { value: "all", label: "All" },
  ];
  // ID160 — "Signpost Alert": when to alert on watchlist signpost triggers.
  const SIGNPOST_ALERT_OPTIONS = [
    { value: "none", label: "None" },
    { value: "when_triggered_only", label: "When triggered only" },
    { value: "when_approaching_triggers", label: "When approaching triggers" },
  ];

  // validation
  const [formErrors, setFormErrors] = useState({
    comp_Name: "",
  });

  // Company name is no longer required (ID30) — nothing mandatory here now.
  const validateNameField = () => {
    setFormErrors({});
    return true;
  };

  // textfield input
  const handleInputChange = (field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (profileSettingFetched.current) return;
    profileSettingFetched.current = true;
    execute("GET", `${protectedResources.apiTodoList.endpoint}/profilesetting/list`).then(
      (response) => {
        if (response && response.success === true && response.data.length > 0) {
          const rec = response.data[0];
          // eslint-disable-next-line no-underscore-dangle
          setFormData({ ...rec, id: rec.id || rec._id || "" });
        }
      }
    );
  }, [execute]);

  useEffect(() => {
    if (userMeFetched.current) return;
    userMeFetched.current = true;
    execute("GET", `${protectedResources.apiTodoList.endpoint}/users/me`).then((response) => {
      if (response?.notificationFrequency) setNotificationFrequency(response.notificationFrequency);
      if (response?.notificationSensitivity) {
        setNotificationSensitivity(response.notificationSensitivity);
      }
      if (response?.notificationSignpostAlert) {
        setNotificationSignpostAlert(response.notificationSignpostAlert);
      }
    });
  }, [execute]);

  // img input — downscale to a small square-ish avatar so the base64 payload stays tiny.
  const handleImageChange = (field, e) => {
    const selectedImage = e.target.files[0];
    if (!selectedImage) {
      handleInputChange(field, "");
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      const img = new Image();
      img.onload = () => {
        const MAX = 256;
        let { width, height } = img;
        if (width > height && width > MAX) {
          height = Math.round((height * MAX) / width);
          width = MAX;
        } else if (height > MAX) {
          width = Math.round((width * MAX) / height);
          height = MAX;
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        handleInputChange(field, canvas.toDataURL("image/jpeg", 0.85));
      };
      img.onerror = () => handleInputChange(field, reader.result);
      img.src = reader.result;
    };
    reader.readAsDataURL(selectedImage);
  };

  // ==========================save dialog box===========================

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate("/home");
  };

  const handleSave = async () => {
    let saved = false;
    const isValid = validateNameField();
    if (isValid) {
      const requestBody = {
        companyName: formData.companyName,
        companyLogo: formData.companyLogo,
        userName: formData.userName,
        userPhoto: formData.userPhoto,
      };
      if (!formData.id) {
        try {
          await execute(
            "POST",
            `${protectedResources.apiTodoList.endpoint}/profilesetting/create`,
            requestBody
          );
          saved = true;
        } catch (error) {
          /* empty */
        }
      } else {
        try {
          await execute(
            "PUT",
            `${protectedResources.apiTodoList.endpoint}/profilesetting/update/${formData.id}`,
            requestBody
          );
          saved = true;
        } catch (error) {
          /* empty */
        }
      }
    }
    try {
      await execute("PUT", `${protectedResources.apiTodoList.endpoint}/users/me/preferences`, {
        notificationFrequency,
        notificationSensitivity,
        notificationSignpostAlert,
      });
      saved = true;
    } catch (error) {
      /* empty */
    }
    // ID30 — update the directory display name (best-effort).
    if ((formData.userName || "").trim()) {
      try {
        await execute("PUT", `${protectedResources.apiTodoList.endpoint}/users/me/displayName`, {
          displayName: formData.userName.trim(),
        });
        saved = true;
      } catch (error) {
        /* empty */
      }
    }
    if (saved) setOpen(true);
  };

  // ID30 — change password via the Entra-backed endpoint.
  const handleChangePassword = async () => {
    setPwError("");
    const complexOk =
      newPassword.length >= 8 &&
      /[A-Z]/.test(newPassword) &&
      /[0-9]/.test(newPassword) &&
      /[^A-Za-z0-9]/.test(newPassword);
    if (!complexOk) {
      setPwError(
        "Password must be at least 8 characters with an uppercase letter, a number, and a special character."
      );
      return;
    }
    if (newPassword !== confirmPassword) {
      setPwError("Passwords do not match.");
      return;
    }
    setPwSaving(true);
    try {
      const res = await execute(
        "POST",
        `${protectedResources.apiTodoList.endpoint}/users/me/password`,
        { newPassword }
      );
      if (res && res.success) {
        setPwDone(true);
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setPwError(res?.error || res?.message || "Could not update password. Please try again.");
      }
    } catch (error) {
      setPwError("Could not update password. Please try again.");
    } finally {
      setPwSaving(false);
    }
  };
  // console.log("============", formData);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox bgColor="white" padding="15px" borderRadius="8px" MinHeight="500px">
        <Grid container spacing={2}>
          <Grid item md={12}>
            <MDTypography fontWeight="medium" fontSize="21px" color="#263445" opacity="1">
              Profile- Settings
            </MDTypography>
            <hr />
          </Grid>
          <Grid item md={12}>
            <Grid container spacing={2}>
              {/* <Grid item md={3}>
                
                <img
                  src={
                    activeAccount?.idTokenClaims?.given_name === "Ramsay"
                      ? Ramsay
                      : activeAccount?.idTokenClaims?.given_name === "Orica"
                      ? Orica
                      : profilePhoto
                  }
                  alt="profilephoto"
                  style={{ width: "100px", height: "100px", marginLeft: "26px" }}
                />
              </Grid> */}
              <Grid item md={12}>
                <MDTypography fontWeight="light" fontSize="17px" color="#263445" opacity="1">
                  Account
                </MDTypography>
              </Grid>
              <Grid item md={9}>
                <Stack spacing={2} sx={{ maxWidth: 520 }}>
                  {/* Profile image + dummy fallback */}
                  <MDBox sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {/* ID111 — generic avatar (MUI person icon) unless the user uploaded their own */}
                    <Avatar
                      src={formData.userPhoto || undefined}
                      alt="Profile"
                      sx={{ width: 72, height: 72 }}
                    />
                    <MDBox>
                      <MDButton variant="outlined" color="dark" component="label">
                        Upload photo
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) => handleImageChange("userPhoto", e)}
                        />
                      </MDButton>
                      {formData.userPhoto ? (
                        <MDButton
                          variant="text"
                          color="error"
                          sx={{ ml: 1 }}
                          onClick={() => handleInputChange("userPhoto", "")}
                        >
                          Remove
                        </MDButton>
                      ) : null}
                      <MDTypography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", mt: 0.5 }}
                      >
                        Saved with the button below. Shown in the top-right corner.
                      </MDTypography>
                    </MDBox>
                  </MDBox>

                  <TextField
                    label="Display name"
                    fullWidth
                    name="userName"
                    value={formData.userName}
                    onChange={(e) => handleInputChange("userName", e.target.value)}
                    helperText="Shown across the app. Saved with the button below."
                  />
                  <MDBox>
                    <MDButton variant="outlined" color="dark" onClick={() => setPasswordOpen(true)}>
                      Change password
                    </MDButton>
                  </MDBox>
                </Stack>
              </Grid>
            </Grid>
            <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
          </Grid>
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={12}>
                <MDTypography fontWeight="light" fontSize="17px" color="#263445" opacity="1">
                  Notification preferences
                </MDTypography>
              </Grid>
              {/* ID112 — legacy single "Notification preference" dropdown removed; ID31 two-axis below */}
              {/* ID31 — two-axis preferences */}
              <Grid item md={9}>
                <MDBox sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                  <FormControl sx={{ minWidth: 220 }}>
                    <InputLabel id="notif-frequency-label">Notification frequency</InputLabel>
                    <Select
                      labelId="notif-frequency-label"
                      label="Notification frequency"
                      value={notificationFrequency}
                      onChange={(e) => setNotificationFrequency(e.target.value)}
                    >
                      {FREQUENCY_OPTIONS.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ minWidth: 240 }}>
                    <InputLabel id="notif-sensitivity-label">Notification sensitivity</InputLabel>
                    <Select
                      labelId="notif-sensitivity-label"
                      label="Notification sensitivity"
                      value={notificationSensitivity}
                      onChange={(e) => setNotificationSensitivity(e.target.value)}
                    >
                      {SENSITIVITY_OPTIONS.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ minWidth: 240 }}>
                    <InputLabel id="notif-signpost-label">Signpost alert</InputLabel>
                    <Select
                      labelId="notif-signpost-label"
                      label="Signpost alert"
                      value={notificationSignpostAlert}
                      onChange={(e) => setNotificationSignpostAlert(e.target.value)}
                    >
                      {SIGNPOST_ALERT_OPTIONS.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MDBox>
                <MDTypography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", mt: 1.5, maxWidth: 560, lineHeight: 1.5 }}
                >
                  <strong>Frequency</strong> controls <strong>email</strong> only (None = no email;
                  Daily/Weekly feed the digest; Immediate emails as they happen).{" "}
                  <strong>Sensitivity</strong> controls the in-app <strong>bell</strong> for Horizon
                  Scan themes — the lowest prioritisation rating that alerts you (e.g. &quot;Extreme
                  only&quot;). <strong>Signpost alert</strong> controls bell/email for watch-list
                  signpost triggers (Triggered only, or also when approaching).
                </MDTypography>
              </Grid>
            </Grid>
            <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
          </Grid>
          <Grid item md={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <MDButton
              color="black"
              variant="outlined"
              // disabled={activeStep === 0}
              // onClick={handleBack}
              width="75px"
              height="36px"
              // onClick={clickedId ? handleNext : handleBack}
              sx={{
                mr: 3.5,
                color: "#263445",
                border: "1px solid #B5BFD0",
                textTransform: "none",
                borderRadius: "4px",
                fontSize: "15px",
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="contained"
              color="#402899"
              sx={{
                color: "#f7f4fb",
                width: "79px",
                height: "36px",
                borderRadius: "4px",
                textTransform: "none",
                fontSize: "15px",
              }}
              onClick={() => handleSave()}
            >
              Save
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
      {/* save dialog box */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Saved Successfully</DialogTitle>
        <DialogActions>
          <Button color="primary" onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* ID30 — change password dialog */}
      <Dialog
        open={passwordOpen}
        onClose={() => {
          setPasswordOpen(false);
          setPwError("");
          setPwDone(false);
          setNewPassword("");
          setConfirmPassword("");
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Change password</DialogTitle>
        <DialogContent>
          {pwDone ? (
            <MDTypography variant="body2" sx={{ color: "#1b5e20", py: 1 }}>
              Your password has been updated. Use it next time you sign in.
            </MDTypography>
          ) : (
            <Stack spacing={2} sx={{ mt: 1 }}>
              <TextField
                label="New password"
                type="password"
                fullWidth
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <TextField
                label="Confirm new password"
                type="password"
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <MDTypography variant="caption" color="text.secondary">
                At least 8 characters, with an uppercase letter, a number, and a special character.
              </MDTypography>
              {pwError ? (
                <MDTypography variant="caption" sx={{ color: "#b71c1c" }}>
                  {pwError}
                </MDTypography>
              ) : null}
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          {pwDone ? (
            <Button
              color="primary"
              onClick={() => {
                setPasswordOpen(false);
                setPwDone(false);
              }}
            >
              Done
            </Button>
          ) : (
            <>
              <Button onClick={() => setPasswordOpen(false)}>Cancel</Button>
              <Button color="primary" disabled={pwSaving} onClick={handleChangePassword}>
                {pwSaving ? "Updating…" : "Update password"}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}
export default Profile;
